import type { z } from 'zod'
import { MenuCategoryStore } from '~/services/api/contracts/requests/MenuCategoryStore'
import type { NoContext } from '~/services/api/contracts/NoContext'
import type { MenuCategoryStoreForPartnerRequestSchema } from '~/services/api/generated'

// Mirrors StoreMenuCategoryRequest, shared with MenuCategoryStore.
export const MenuCategoryStoreForPartner = (
  context: NoContext
): z.ZodType<z.output<typeof MenuCategoryStoreForPartnerRequestSchema>> =>
  MenuCategoryStore(context)
